import React, { memo } from 'react'
import { Path, Circle as _Circle } from 'react-native-svg'

import { IconProps } from '../IconProps'
import { IconBase } from '../IconBase'
import { themed } from '../themed'

const Icon = (props) => {
  const { color = 'black', size = 24, ...otherProps } = props
  return (
    <IconBase
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <Path
        d="M16.5 7.5C16.5 7.20163 16.6185 6.91548 16.8295 6.7045C17.0405 6.49353 17.3266 6.375 17.625 6.375H20.25C20.5484 6.375 20.8345 6.49353 21.0455 6.7045C21.2565 6.91548 21.375 7.20163 21.375 7.5C21.375 7.79837 21.2565 8.08452 21.0455 8.2955C20.8345 8.50647 20.5484 8.625 20.25 8.625H17.625C17.3266 8.625 17.0405 8.50647 16.8295 8.2955C16.6185 8.08452 16.5 7.79837 16.5 7.5ZM3.75 8.625H12.75V9.75C12.75 10.0484 12.8685 10.3345 13.0795 10.5455C13.2905 10.7565 13.5766 10.875 13.875 10.875C14.1734 10.875 14.4595 10.7565 14.6705 10.5455C14.8815 10.3345 15 10.0484 15 9.75V5.25C15 4.95163 14.8815 4.66548 14.6705 4.4545C14.4595 4.24353 14.1734 4.125 13.875 4.125C13.5766 4.125 13.2905 4.24353 13.0795 4.4545C12.8685 4.66548 12.75 4.95163 12.75 5.25V6.375H3.75C3.45163 6.375 3.16548 6.49353 2.9545 6.7045C2.74353 6.91548 2.625 7.20163 2.625 7.5C2.625 7.79837 2.74353 8.08452 2.9545 8.2955C3.16548 8.50647 3.45163 8.625 3.75 8.625ZM20.25 15.375H11.625C11.3266 15.375 11.0405 15.4935 10.8295 15.7045C10.6185 15.9155 10.5 16.2016 10.5 16.5C10.5 16.7984 10.6185 17.0845 10.8295 17.2955C11.0405 17.5065 11.3266 17.625 11.625 17.625H20.25C20.5484 17.625 20.8345 17.5065 21.0455 17.2955C21.2565 17.0845 21.375 16.7984 21.375 16.5C21.375 16.2016 21.2565 15.9155 21.0455 15.7045C20.8345 15.4935 20.5484 15.375 20.25 15.375ZM7.875 13.125C7.57663 13.125 7.29048 13.2435 7.0795 13.4545C6.86853 13.6655 6.75 13.9516 6.75 14.25V15.375H3.75C3.45163 15.375 3.16548 15.4935 2.9545 15.7045C2.74353 15.9155 2.625 16.2016 2.625 16.5C2.625 16.7984 2.74353 17.0845 2.9545 17.2955C3.16548 17.5065 3.45163 17.625 3.75 17.625H6.75V18.75C6.75 19.0484 6.86853 19.3345 7.0795 19.5455C7.29048 19.7565 7.57663 19.875 7.875 19.875C8.17337 19.875 8.45952 19.7565 8.6705 19.5455C8.88147 19.3345 9 19.0484 9 18.75V14.25C9 13.9516 8.88147 13.6655 8.6705 13.4545C8.45952 13.2435 8.17337 13.125 7.875 13.125Z"
        fill={`${color}`}
      />
    </IconBase>
  )
}

Icon.displayName = 'IconFaders'

export const IconFaders = memo(themed(Icon))
